import { any, z } from "zod";

export const UserQualificationFieldsSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  isActive: z.boolean(),
  createdAt: z.string(),
  modificationDate: z.string().nullable(),
});
export const PartialUserQualificationFieldsSchema =
  UserQualificationFieldsSchema.deepPartial();

export const UserQualificationAssignmentFileSchema = z.object({
  id: z.number(),
  position: z.number(),
  fileData: any(),
});

export const UserQualificationAssignmentFieldsSchema = z.object({
  id: z.number(),
  obtainedAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  certificateNumber: z.string().nullable(),
  createdAt: z.string(),
  qualification: UserQualificationFieldsSchema,
  files: z.array(UserQualificationAssignmentFileSchema).optional().default([]),
});
export const PartialUserQualificationAssignmentFieldsSchema =
  UserQualificationAssignmentFieldsSchema.deepPartial();

export type UserQualificationFields = z.infer<
  typeof UserQualificationFieldsSchema
>;
export type PartialUserQualificationFields = z.infer<
  typeof PartialUserQualificationFieldsSchema
>;
export type UserQualification = z.infer<typeof UserQualificationFieldsSchema>;

export type UserQualificationAssignmentFields = z.infer<
  typeof UserQualificationAssignmentFieldsSchema
>;
export type PartialUserQualificationAssignmentFields = z.infer<
  typeof PartialUserQualificationAssignmentFieldsSchema
>;
